// 给组件添加自定义状态
// composables/useComponentsState.ts
import { ref, onMounted, onUnmounted, type Ref } from 'vue'

interface UseActiveStateOptions {
  /** 是否在组件挂载时自动添加全局监听 */
  autoListen?: boolean
  /** 失焦时的回调 */
  onBlur?: () => void
  /** 聚焦时的回调 */
  onFocus?: () => void
}

/**
 * 管理组件的激活/失焦状态
 * @param elementRef 组件元素的 ref
 * @param options 配置选项
 * @returns 激活状态
 */
export function useActiveState(
  elementRef: Ref<HTMLElement | null>,
  options: UseActiveStateOptions = {},
) {
  const { autoListen = true, onBlur, onFocus } = options

  const isActive = ref(false)

  const handleGlobalClick = (e: MouseEvent) => {
    if (!elementRef.value) return

    const isClickInside = elementRef.value.contains(e.target as Node)

    // 点击内部且未激活 -> 聚焦
    if (isClickInside && !isActive.value) {
      isActive.value = true
      onFocus?.()
    }
    // 点击外部且已激活 -> 失焦
    else if (!isClickInside && isActive.value) {
      isActive.value = false
      onBlur?.()
    }
  }

  if (autoListen) {
    onMounted(() => {
      document.addEventListener('click', handleGlobalClick)
    })

    onUnmounted(() => {
      document.removeEventListener('click', handleGlobalClick)
    })
  }

  return {
    isActive,
  }
}
